import Actions from '../../odata/actions';

const actions = new Actions('readinessState', 'readinessStates');
const customActions = {};

export default { ...actions, ...customActions };
